/* Site-Specific JavaScript */

(function(d, s, id) {
    var js, tjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://app.termly.io/embed-policy.min.js";
    tjs.parentNode.insertBefore(js, tjs);
    }(document, 'script', 'termly-jssdk'));

jq(document).ready(function () {    
    if (jq('body').hasClass('page-type-qmod---quote')) {
        observeForContent('.highcharts-container')
            .then(() => {
                jq('.highcharts-container').attr('role', 'marquee');
            });
    }
    // Toggle Client Mobile Menu
    jq(".elementor-menu-toggle").on("click", function(){
        jq(this).toggleClass("elementor-active");
        jq(".elementor-nav-menu--dropdown.elementor-nav-menu__container").toggleClass("acsb-active");
    });
    jq("li.menu-item-has-children").hover(function(){
        jq(this).children("ul").removeClass("acsb-hidden");
        jq(this).children("a").addClass("highlighted");
        jq(this).children("ul").addClass("sm-wrap");
    }, function(){
        jq(this).children("ul").addClass("acsb-hidden");
        jq(this).children("a").removeClass("highlighted");
        jq(this).children("ul").removeClass("sm-wrap");
    });
    // end Toggle Client Mobile Menu
});

function observeForContent(selector) {
    return new Promise((resolve, reject) => {
        let checkInterval = setInterval(() => {
            if (jq(selector).html()) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100); // Check every 100 milliseconds
    });
}